import request from '@/utils/request'

/**
 * 获取用户列表数据
 */
export const getInstancesByUserName = () => {
  return request({
    url: '/mj/activitiHistory/getInstancesByUserName'
  })
}
